import VRuntimeTemplate from 'v-runtime-template'

import { nl2br, getCleanLink } from '@/helpers'

const replace = process.env.VUE_APP_DEV_DIST_URL ? process.env.VUE_APP_DEV_DIST_URL : `${window.location.protocol}//${window.location.hostname}`

export default {
  name: 'wysiwyg',
  components: {
    VRuntimeTemplate
  },
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    template: function () {
      return this.wysiwygToTemplate(this.text)
    }
  },
  methods: {
    wysiwygToTemplate (text) {
      let cleanText = text

      // Replace internal links with link-router
      const regex = /<a([^href].*?)href="([^"]*?)"([^>]*?)>([^<]*?)<\/a>/g
      cleanText = cleanText.replace(regex, (match, beforeUrl, url, afterUrl, content, shift, string) => {
        const link = url.replace(replace, '')
        return link !== url ? `<router-link${beforeUrl}to="${getCleanLink(url)}"${afterUrl}>${content}</router-link>` : match
      })
      return `<div>${nl2br(cleanText)}</div>`
    }
  }
}
